import { Navigate, useParams } from 'react-router';

import { NotFoundPage } from '@/app/shell/NotFoundPage';
import { base64ToGuid, tryParseGuid } from './model/base64IncidentId';
import { IncidentDetailPage } from './IncidentDetailPage';

export function IncidentDetailRoute() {
  const { incidentId } = useParams<'incidentId'>();

  if (incidentId === undefined) {
    return <NotFoundPage />;
  }

  const parsedGuid = tryParseGuid(incidentId);
  if (parsedGuid !== null) {
    return <IncidentDetailPage key={parsedGuid} incidentId={parsedGuid} />;
  }

  let redirectTarget: string;
  try {
    redirectTarget = base64ToGuid(incidentId);
  } catch {
    return <NotFoundPage />;
  }

  return <Navigate to={`/incident/${redirectTarget}`} />;
}
